import { useState } from 'react'
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment'
import styled from 'styled-components'

const Container = styled.div`

`
const Wrapper = styled(TimePicker)`
    display: block;
    .rc-time-picker-input{       
        border: 0px solid #d9d9d9;
        font-size: 1.1rem;
        font-weight: 500;
        background-color: #F5F8FA;
        height:auto;
    }

`
export const RCTimePicker = (props) => {
    return (
        <Container className="form-control form-control-solid">
            <Wrapper showSecond={false} use12Hours={false} {...props} />
        </Container>
    )
}
